// Per-family rates (USD per 1M tokens). Version-agnostic: matched by family
// substring so claude-sonnet-5, claude-opus-5, etc. resolve automatically.
// Rates match Anthropic published pricing as of 2026-08 for the 4-series;
// 5-series prices are assumed at the same tier until we have confirmed numbers.
const FAMILY_PRICING: Record<string, { input: number; output: number; cacheRead: number; cacheWrite: number }> = {
  "opus":   { input: 15, output: 75,  cacheRead: 1.875, cacheWrite: 18.75 },
  "sonnet": { input: 3,  output: 15,  cacheRead: 0.3,   cacheWrite: 3.75  },
  "haiku":  { input: 0.8, output: 4,  cacheRead: 0.08,  cacheWrite: 1.0   },
};

// Unknown models fall back to Sonnet tier (the most common; avoids the
// ~18× overestimate that Opus defaults would cause for real Sonnet sessions).
const DEFAULT_PRICING = FAMILY_PRICING["sonnet"];

function resolvePricing(model: string) {
  const normalized = model.replace(/"/g, "").toLowerCase();
  for (const [family, pricing] of Object.entries(FAMILY_PRICING)) {
    if (normalized.includes(family)) return pricing;
  }
  return DEFAULT_PRICING;
}

export function estimateCost(item: {
  input_tokens: number;
  output_tokens: number;
  cache_read: number;
  cache_write: number;
  model?: string | null;
}): number {
  const p = resolvePricing(item.model ?? "unknown");
  const M = 1_000_000;
  return (
    (item.input_tokens / M) * p.input +
    (item.output_tokens / M) * p.output +
    (item.cache_read / M) * p.cacheRead +
    (item.cache_write / M) * p.cacheWrite
  );
}

export { formatCost, formatTokens } from "@/lib/format";
